export const CARD_SENT_TO_BACKGROUND_SCALE = 0.95